import BaseStore from '@src/utils/store/base-store';
import { observable } from 'mobx';
import { autobind } from 'core-decorators';
import { useRequest } from 'ahooks';
import cmsApi from '@src/services/cms-api';
import { CMS_CATEGORY_ID, CMS_API, ARTICLE_ID } from '@src/constants/articles';

class ComponentStore extends BaseStore {
  // 内页单篇 CMS 内容（HTML，内含写死 id 锚点小节）
  @observable contentHtml = '';

  /**
   * 拉取单篇文章详情
   * @returns {Promise<*>}
   */
  @autobind
  async fetchArticleDetailAsync() {
    return cmsApi.getArticleDetail({
      categoryId: CMS_CATEGORY_ID,
      articleId: ARTICLE_ID.BATTLE_TERRITORY,
      api: CMS_API
    });
  }

  use(props) {
    super.use(props);

    useRequest(this.fetchArticleDetailAsync, {
      onSuccess: res => {
        // 归一化为稳定 ViewModel：本项目 getArticleDetail 返回单个对象，
        // 防御兼容数组结构，空值兜底为 ''（viewmodel-first / api-response-verification）
        const detail = Array.isArray(res) ? res[0] : res;
        this.contentHtml = (detail && detail.content) || '';
      }
    });
  }
}

export default ComponentStore;
